module.exports = __webpack_public_path__ + "media/images/emblems/Pratteln-coat_of_arms-ec146d777ce58e1999d91bbe52eb4e14.svg";